import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import type { FunctionComponent, SVGProps } from 'react';

type VoiceIconProps = SVGProps<SVGSVGElement> & {
    readonly isAnimating?: boolean;
};

const pulse1 = keyframes`
    0%, 100% { transform: scaleY(1); }
    50% { transform: scaleY(0.5); }
`;

const pulse2 = keyframes`
    0%, 100% { transform: scaleY(1); }
    50% { transform: scaleY(1.3); }
`;

const pulse3 = keyframes`
    0%, 100% { transform: scaleY(1); }
    50% { transform: scaleY(0.7); }
`;

const pulse4 = keyframes`
    0%, 100% { transform: scaleY(1); }
    50% { transform: scaleY(1.2); }
`;

const pulse5 = keyframes`
    0%, 100% { transform: scaleY(1); }
    50% { transform: scaleY(0.6); }
`;

const AnimatedSvg = styled.svg<{ readonly $isAnimating: boolean }>`
    .bar-1 {
        transform-origin: center;
        animation: ${({ $isAnimating }) => ($isAnimating ? pulse1 : 'none')} 0.6s ease-in-out infinite;
    }
    .bar-2 {
        transform-origin: center;
        animation: ${({ $isAnimating }) => ($isAnimating ? pulse2 : 'none')} 0.5s ease-in-out infinite;
        animation-delay: 0.1s;
    }
    .bar-3 {
        transform-origin: center;
        animation: ${({ $isAnimating }) => ($isAnimating ? pulse3 : 'none')} 0.7s ease-in-out infinite;
        animation-delay: 0.05s;
    }
    .bar-4 {
        transform-origin: center;
        animation: ${({ $isAnimating }) => ($isAnimating ? pulse4 : 'none')} 0.55s ease-in-out infinite;
        animation-delay: 0.15s;
    }
    .bar-5 {
        transform-origin: center;
        animation: ${({ $isAnimating }) => ($isAnimating ? pulse5 : 'none')} 0.65s ease-in-out infinite;
        animation-delay: 0.08s;
    }
`;

export const VoiceIcon: FunctionComponent<VoiceIconProps> = ({ isAnimating = false, ...props }) => (
    <AnimatedSvg {...props} $isAnimating={isAnimating} viewBox="0 0 13 12">
        <line className="bar-1" stroke="currentColor" strokeLinecap="round" x1="2.25" x2="2.25" y1="4.75" y2="7.25" />
        <line className="bar-2" stroke="currentColor" strokeLinecap="round" x1="4.25" x2="4.25" y1="1.75" y2="10.25" />
        <line className="bar-3" stroke="currentColor" strokeLinecap="round" x1="6.5" x2="6.5" y1="3.75" y2="8.25" />
        <line className="bar-4" stroke="currentColor" strokeLinecap="round" x1="8.75" x2="8.75" y1="2.75" y2="9.25" />
        <line className="bar-5" stroke="currentColor" strokeLinecap="round" x1="10.75" x2="10.75" y1="4.75" y2="7.25" />
    </AnimatedSvg>
);
